import { render, staticRenderFns } from "./Stories.vue?vue&type=template&id=036ffce7&"
import script from "./Stories.vue?vue&type=script&lang=js&"
export * from "./Stories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports